import type { GeneratedTemplate } from "../AiEmail/AiCampaignTypes";
import {
  clearSessionSnapshot,
  isStringArray,
  readSessionSnapshot,
  writeSessionSnapshot,
} from "../AiEmail/WizardSnapshot";

export interface TemplateWizardSnapshot {
  stepIndex: number;
  campaignName: string;
  subjectLine: string;
  sendTo: string[];
  excludeList: string[];
  replyTo: string;
  template: GeneratedTemplate | null;
}

const TEMPLATE_WIZARD_PREFIX = "email-template-wizard:";

const isSnapshot = (value: unknown): value is TemplateWizardSnapshot =>
  typeof value === "object" &&
  value !== null &&
  "stepIndex" in value &&
  typeof value.stepIndex === "number" &&
  "campaignName" in value &&
  typeof value.campaignName === "string" &&
  "subjectLine" in value &&
  typeof value.subjectLine === "string" &&
  "sendTo" in value &&
  isStringArray(value.sendTo) &&
  "excludeList" in value &&
  isStringArray(value.excludeList) &&
  "replyTo" in value &&
  typeof value.replyTo === "string";

export const readTemplateWizardSnapshot = (key: string) =>
  readSessionSnapshot(TEMPLATE_WIZARD_PREFIX + key, isSnapshot);

export const writeTemplateWizardSnapshot = (key: string, snapshot: TemplateWizardSnapshot) =>
  writeSessionSnapshot(TEMPLATE_WIZARD_PREFIX + key, snapshot);

export const clearTemplateWizardSnapshot = (key: string) =>
  clearSessionSnapshot(TEMPLATE_WIZARD_PREFIX + key);
